import {handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useMembersPageActions, useMembersPageSelector} from '../../../hooks/runtime'
import {EventLink} from '../../styled-components/event-link'
import {DetailsButtonProps} from './interfaces'

export const DetailsButton = ({event}: DetailsButtonProps) => {
  const {t} = useTranslation()
  const mobile = useMembersPageSelector(isMobile)
  const {navigateToDetailsPage} = useMembersPageActions()

  const handleClick = () => navigateToDetailsPage({event})

  return (
    <EventLink
      primary
      mobile={mobile}
      as="a"
      onKeyPress={handleKeyPressEnterOrSpace(handleClick)}
      onClick={handleClick}
      data-hook={DH.BUTTON_GO_TO_DETAILS}
    >
      {t('events.buttons.go-to-details')}
    </EventLink>
  )
}
